import animationData from '@static/animations/7_questions.json';
import Lottie from 'lottie-react';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { appPaths } from '~/routes/app-paths';

import * as S from './NotFound.styles';

export const NotFound = () => {
  const { t } = useTranslation(['error', 'common']);
  const title = t('error:notFound.title');
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <S.Main data-testid="not-found-page">
        <S.NotFoundSection>
          <div>
            <S.AnimationContainer>
              <Lottie loop autoplay animationData={animationData} />
            </S.AnimationContainer>
            <S.Title data-testid="title">
              {t('error:notFound.pageTitle')}
            </S.Title>
          </div>
          <S.Description>{t('error:notFound.pageText')}</S.Description>
          <S.LinkButton
            data-testid="back-action"
            onClick={() => navigate(appPaths.base)}
            label={t('error:notFound.pageButtonText')}
            size="large"
          />
        </S.NotFoundSection>
      </S.Main>
    </>
  );
};
